import {escapeHtml, escapeJs} from '@malt/sanitize';

export default (code, ...args) => {
    if (typeof code === 'undefined' || code === null) {
        return code;
    }

    const options = args[args.length - 1];
    if (Array.isArray(options.hash.arguments)) {
        args = options.hash.arguments;
    } else {
        args = args.slice(0, args.length - 1);
    }

    let msg = Hop.message(code, args);

    if (options.hash.escapeJs) {
        msg = escapeJs(msg);
    }

    if (options.hash.escapeHtml) {
        msg = escapeHtml(msg);
    }

    return new Handlebars.SafeString(msg);
};
